import { gql, useMutation } from '@apollo/client';

const useSetObservationToEducator = (onCompleted = () => {}, onError = () => {}) => {
  return useMutation(
    gql`
      mutation SetObservationToEducator($educatorId: ID!, $classLink: String!) {
        setObservationToEducator(educatorId: $educatorId, classLink: $classLink) {
          id
          firstName
          lastName
          educatorInfo {
            observationsDates {
              date
              staffId
              staffName
              classLink
            }
          }
        }
      }
    `,
    {
      onCompleted,
      onError,
    }
  );
};

export default useSetObservationToEducator;
